import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `https://api.infrequent.net/`,
    withCredentials: false,
    headers: {
      'Authorization': localStorage.token,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}
